import { configureStore } from "@reduxjs/toolkit";
import categoriesReducer from "./components/Aside/categoriesSlice";
import postPreviewReducer from "./components/PostPreview/postPreviewSlice";
import searchReducer from "./features/searchSlice";
import postReducer from "./components/Post/postSlice";

export default configureStore({
  reducer: {
    categories: categoriesReducer,
    search: searchReducer,
    postPreview: postPreviewReducer,
    post: postReducer,
  },
});
